module.exports = __webpack_public_path__ + "img/1080_16.c53471d0.jpg";